import { useState, useEffect } from 'react';
import { getCommitteeData } from '../../prefetchNames';

export default function AdvisoryCommittee() {
  const [hoveredAnjumanCard, setHoveredAnjumanCard] = useState(null);
  const [anjumanMembers, setAnjumanMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
    async function loadCommitteeData() {
        try {
        const data = await getCommitteeData();

        const filteredMembers = (data.anjuman || []).filter((member) =>
            member.desc?.toLowerCase() === 'advisory'
        );

        setAnjumanMembers(filteredMembers);
        } catch (error) {
        console.error('Failed to load Advisory Committee data:', error);
        } finally {
        setIsLoading(false);
        }
    }

    loadCommitteeData();
    }, []);

  return (
    <div className="min-h-screen bg-white">


      {/* Hero */}
      <div
        className="relative py-20 text-white overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #001f3f 0%, #003d66 100%)' }}
      >
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 right-20 w-64 h-64 rounded-full border-2 border-dawoodi-gold/30"></div>
          <div className="absolute bottom-10 left-20 w-48 h-48 rounded-full border-2 border-dawoodi-gold/30"></div>
        </div>
      </div>

      {/* Loading */}
      {isLoading && (
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 animate-pulse">

          <div className="flex items-center justify-center mb-6">
            <p className="font-poppins text-sm tracking-wide text-gray-500 uppercase animate-pulse">
              Loading...
            </p>
          </div>

          <div className="h-10 w-64 bg-gray-200 rounded mb-10"></div>

          <div className="space-y-4">
            {[...Array(6)].map((_, index) => (
              <div
                key={index}
                className="h-24 bg-gray-100 border-2 border-dawoodi-gold/10 rounded-xl"
              ></div>
            ))}
          </div>
        </div>
      )}

      {/* Content */}
      <div
        className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 transition-opacity duration-500 ${
          isLoading ? 'opacity-0 hidden' : 'opacity-100'
        }`}
      >
        <div className="mb-10">
          <div className="flex items-center space-x-3 mb-4">
            <div className="w-1 h-8 bg-gradient-to-b from-dawoodi-gold to-transparent rounded-full"></div>
            <h2 className="font-playfair text-4xl md:text-5xl font-bold text-dawoodi-navy">
              Advisory Committee
            </h2>
          </div>
        </div>

        <div className="space-y-4">
          {anjumanMembers.map((member, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredAnjumanCard(index)}
              onMouseLeave={() => setHoveredAnjumanCard(null)}
              className={`group relative cursor-pointer transition-all duration-300 ${
                hoveredAnjumanCard === index ? 'scale-105' : ''
              }`}
            >
              <div
                className={`absolute inset-0 rounded-xl transition-all duration-300 ${
                  hoveredAnjumanCard === index
                    ? 'bg-dawoodi-gold/5 blur-xl opacity-100'
                    : 'opacity-0'
                }`}
              ></div>

              <div
                className={`relative bg-gradient-to-br border-2 transition-all duration-300 rounded-xl p-5 ${
                  member.role === 'Leadership'
                    ? 'from-white via-dawoodi-light/30 to-white border-dawoodi-gold/40 hover:border-dawoodi-gold'
                    : 'from-white to-dawoodi-light/10 border-dawoodi-gold/15 hover:border-dawoodi-gold/40'
                } ${hoveredAnjumanCard === index ? 'shadow-xl' : 'shadow-md'}`}
              >
                <div
                  className={`absolute top-0 left-0 right-0 h-1 rounded-t-xl transition-all duration-300 ${
                    member.role === 'Leadership'
                      ? 'bg-gradient-to-r from-dawoodi-gold to-transparent'
                      : 'bg-gray-200'
                  }`}
                ></div>

                <div className="flex items-start justify-between mb-3">
                  <div className="flex-1 min-w-0">
                    <h4
                      className={`font-playfair font-bold text-sm leading-tight mb-1 transition-colors ${
                        hoveredAnjumanCard === index
                          ? 'text-dawoodi-gold'
                          : 'text-dawoodi-navy'
                      }`}
                    >
                      {member.title}
                    </h4>

                    <p className="font-poppins text-xs text-gray-600">
                      {member.desc}
                    </p>
                  </div>

                  <div
                    className={`ml-3 flex-shrink-0 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide whitespace-nowrap ${
                      member.role === 'Leadership'
                        ? 'bg-dawoodi-gold/15 text-dawoodi-gold'
                        : 'bg-gray-100 text-gray-600'
                    }`}
                  >
                    {member.role === 'Leadership' ? '★' : '◇'}
                  </div>
                </div>

                <div
                  className={`absolute bottom-0 left-0 h-1 rounded-b-xl transition-all duration-500 ${
                    hoveredAnjumanCard === index
                      ? 'w-full bg-dawoodi-gold'
                      : 'w-0 bg-dawoodi-gold'
                  }`}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}